import React from "react";
import ResponsiveHeader from "./ResponsiveHeader";
import { RestaurantSidebar } from "../sidebar/RestaurantSidebar";
import { LogoutModal } from "../LogoutModal";
import { useFetchUnreadNotices } from "@/hooks/notice/useFetchUnreadNotices";
import { IoNotificationsOutline } from "react-icons/io5";
import {
    Box,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Text,
    MenuGroup,
    MenuDivider,
    IconButton,
    Flex,
    ListItem
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

const NoticeMenu = ({ restaurantId }: { restaurantId: string }) => {
    const { notices, isLoading } = useFetchUnreadNotices(restaurantId);
    if (isLoading || !notices) return null;

    return (
        <Flex>
            <Menu>
                <MenuButton
                    as={IconButton}
                    aria-label="Notifications"
                    icon={<IoNotificationsOutline size="20px" />}
                    size="sm"
                    colorScheme="whiteAlpha"
                    variant="ghost"
                />
                <MenuList maxW="320px" maxH="450px" overflowY="auto">
                    <MenuGroup title={`未読（${notices.length}件）`}>
                        {notices.map((notice, index) => (
                            <MenuItem key={index} as={Link} to={`notices/${notice.id}`}>
                                <Text fontSize="sm">{notice.title || "新しい通知"}</Text>
                            </MenuItem>
                        ))}
                    </MenuGroup>
                    <MenuDivider my="20px" />
                    <MenuItem as={Link} to="notices">
                        <Text fontSize="sm">すべて見る</Text>
                    </MenuItem>
                </MenuList>
            </Menu>
            <ListItem pt={1.5} ml={2}>
                <LogoutModal />
            </ListItem>
        </Flex>
    );
};

interface RestaurantHeaderProps {
    restaurantId: string;
}

export const RestaurantHeader: React.FC<RestaurantHeaderProps> = ({ restaurantId }) => {
    return (
        <ResponsiveHeader
            name={null}
            title="BLOCKs"
            navItems={[<NoticeMenu restaurantId={restaurantId} key="notice" />]}
            sidebar={<RestaurantSidebar restaurantId={restaurantId} />}
        />
    );
};

export default RestaurantHeader;